<script>

    import { replace, location } from 'svelte-spa-router'
    import { modalStore, userStore } from '../stores'

    import StorageService from '../$services/storage.service'

    import Modal from '../$components/modal.id.svelte'

    import Wallet from '../wallets/component.wallet.svelte'
    import Coverage from '../quotations/component.quotation.delivery.info.svelte'

    function onLogout() {
        StorageService.deleteItem("user");
        StorageService.deleteItem("access");
        replace("#/");
        window.location = '/'
    }
    
</script>

<section class="hero nav is-primary">
    <div class="hero-body">
        <div class="container">
            <div class="brand">
                <div class="title">TIL</div>
                <div class="subtitle">Tecnología en Integración Logistica</div>
            </div>
            <div class="items-end">
                <div class="items-end">
                    <div class="space-right">
                        <div on:click={() => modalStore.set('coverage_modal')} class="icon-text pointer" style="color: white;">
                            <span class="icon"><i class="fas fa-search-location"></i></span>
                            <span>Cobertura</span>
                        </div>
                    </div>
                    {#if !$userStore.hidePrices}
                        <div class="space-right"> 
                            <Wallet />
                        </div>
                    {/if}
                    <div on:click={() => replace('#/settings')} class="icon-text" style="color: white;">
                        <span class="icon"><i class="fas fa-user"></i></span>
                        <span>{ $userStore.name }</span>
                    </div>
                </div>
            </div>
            <div class="items-end">
                <div on:click={onLogout} class="icont-text pointer" style="color: white;">
                    <span class="icon"><i class="fas fa-sign-out-alt"></i></span>
                    <span>Cerrar sesión</span>
                </div>
            </div>
        </div>
    </div>

    <!-- svelte-ignore a11y-missing-attribute -->

    <div class="hero-foot">
        <nav class="tabs is-centered is-boxed is-fullwidth">
            <div class="container">
                <ul>
                    <li class:is-active={ $location === '/home' }>
                        <a on:click={() => replace('#/home')}>
                            <span class="icon"><i class="fas fa-chart-pie"></i></span>
                            <span>Dashboard</span>
                        </a>
                    </li>
                    <li class:is-active={ $location === '/quotations' }>
                        <a on:click={() => replace('#/quotations')}>
                            <span class="icon"><i class="fas fa-calculator"></i></span>
                            <span>Documentador</span>
                        </a>
                    </li>
                    <li class:is-active={ $location === '/shipments' }>
                        <a on:click={() => replace('#/shipments')}>
                            <span class="icon"><i class="fas fa-truck"></i></span>
                            <span>Envios</span>
                        </a>
                    </li>
                    <li class:is-active={ $location === '/orders' }>
                        <a on:click={() => replace('#/orders')}>
                            <span class="icon"><i class="fas fa-clipboard-list"></i></span>
                            <span>Ordenes</span>
                        </a>
                    </li>
                    <li class:is-active={ $location === '/tracing' }>
                        <a on:click={() => replace('#/tracing')}>
                            <span class="icon"><i class="fas fa-exclamation-circle"></i></span>
                            <span>Seguimiento</span>
                        </a>
                    </li>
                    <li class:is-active={ $location === '/settings' }>
                        <a on:click={() => replace('#/settings')}>
                            <span class="icon"><i class="fas fa-user-cog"></i></span>
                            <span>Configuración</span>
                        </a>
                    </li>
                </ul>
            </div>
        </nav>
    </div>
</section>

<Modal id="coverage_modal" title="Validar cobetura de destino">
    <Coverage />
</Modal>